import { CheckCircle } from '@mui/icons-material';
import { Avatar } from '@mui/material';

interface Props {
  onClick?: () => void;
  label?: string;
  avatarUrl?: string;
  selected?: boolean;
}

export const PillButton = ({
  label, avatarUrl, selected, onClick,
}: Props) => {
  const color = selected ? 'bg-mediumgray text-white' : '';
  const checkColor = selected ? 'secondary' : 'info';

  return (
    <button
      type="button"
      data-testid={`pill-${label}`}
      className={`flex items-center border border-mediumgray font-semibold px-2 py-1 rounded-xl hover:bg-lightgray ${color}`}
      onClick={onClick}
      disabled={!onClick}
    >
      {avatarUrl && !selected ? (
        <Avatar
          src={avatarUrl}
          alt={label}
          className="mr-2"
          sx={{ width: 24, height: 24 }}
        />
      ) : <CheckCircle color={checkColor} className="mr-2" />}
      {label}
    </button>
  );
};
